const pagesIndividualPlacesEn = {
  detail: {
    tabs: {
      devices: 'Devices',
      equipments: 'Equipment'
    }
  },
  headers: {
    deviceCount: 'Devices',
    equipmentCount: 'Equipment',
    location: 'Location',
    name: 'Place',
    responsiblePerson: 'Oversight Persons'
  },
  pageTitle: 'Places',
  tabs: {
    managedPlace: 'My Oversight Places'
  }
};
export default pagesIndividualPlacesEn;